/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { DeviceInterfaceType } from './DeviceInterfaceType';
import {
    instanceOfDeviceInterfaceType,
    DeviceInterfaceTypeFromJSON,
    DeviceInterfaceTypeFromJSONTyped,
    DeviceInterfaceTypeToJSON,
} from './DeviceInterfaceType';

/**
 * @type CreateOtherQaEquipmentDtoDeviceInterfaceType
 * 
 * @export
 */
export type CreateOtherQaEquipmentDtoDeviceInterfaceType = DeviceInterfaceType;


export function CreateOtherQaEquipmentDtoDeviceInterfaceTypeFromJSON(json: any): CreateOtherQaEquipmentDtoDeviceInterfaceType {
    return CreateOtherQaEquipmentDtoDeviceInterfaceTypeFromJSONTyped(json, false);
}

export function CreateOtherQaEquipmentDtoDeviceInterfaceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOtherQaEquipmentDtoDeviceInterfaceType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...DeviceInterfaceTypeFromJSONTyped(json, true) };
    return  DeviceInterfaceTypeFromJSONTyped(json, true);
}

export function CreateOtherQaEquipmentDtoDeviceInterfaceTypeToJSON(value?: CreateOtherQaEquipmentDtoDeviceInterfaceType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfDeviceInterfaceType(value)) {
        return DeviceInterfaceTypeToJSON(value as DeviceInterfaceType);
    }

    return {};
}

/**
 * Check if a given object implements the CreateOtherQaEquipmentDtoDeviceInterfaceType interface.
 */
export function instanceOfCreateOtherQaEquipmentDtoDeviceInterfaceType(value: any): value is CreateOtherQaEquipmentDtoDeviceInterfaceType {
    if (instanceOfDeviceInterfaceType(value)) return true;
    return false;
}

